import 'prismjs/components/prism-php';
import 'prismjs/components/prism-jsx';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-php-extras';
import 'prismjs/components/prism-bash';

export default {
  colors: {
    text: "white",
    background: "black",
    primary: "#e6db74",
    secondary: "green",
  },
  fonts: {
    body: "Arial",
    heading: "Arial",
  },
  styles: {
    CodeSurfer: {
      pre: {
        color: "text",
        backgroundColor: "black",
      },
      code: {
        fontFamily: "Inconsolata",
        color: "text",
        backgroundColor: "black",
      },
      tokens: {
        "comment cdata doctype": {
          fontStyle: "italic",
        },
        "builtin changed deleted char inserted": {
          color: "primary",
        },
        operator: {
          color: "#f92672",
        },
        punctuation: {
          color: "#f92672",
        },
        keyword: {
          color: "#f92672",
        },
        tag: {
          color: "#f92672",
        },
        "attr-value": {
          color: "#e6db74",
        },
        "attr-name": {
          color: "#a6e22e",
        },
        property: {
          color: "#66d9ef",
        },
        selector: {
          color: "red",
        },
        entity: {
          color: "red",
        },
        atrule: {
          color: "red",
        },
        string: {
          color: "#e6db74",
        },
        number: {
          color: "#ae81ff",
        },
        function: {
          color: "#a6e22e",
        },
        parameter: {
          color: "#fd971f",
        },
        comment: {
          color: "grey",
        },
        boolean: {
          color: "#ae81ff",
        },
        method: {
          color: "#a6e22e",
        },
      },
      title: {
        backgroundColor: "rgb(35, 36, 31)",
        color: "white",
        fontSize: "30px",
        marginBottom: "20px",
        padding: "10px"
      },
      subtitle: {
        backgroundColor: "black",
        color: "white",
      },
      unfocused: {
        // only the opacity of unfocused code can be changed
        opacity: 0.5,
      },
    },
  },
};
